import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { dynamicImage } from "../utils";
import { routes } from "../routers/routes";
import SignInForm from "./SignInForm";
import { Image } from "../coreComponents/Image";
import ApiService from "../services/apiService";
import LoadingComponent from "../components/lodingComponent";

const Auth = () => {
  const [projectData, setProjectData] = useState<any>([]);
  const [loading, setLoading] = useState(true)
  
  useEffect(() => {
    setLoading(true)
    const fetchProjects = async () => {
     
      try {
        const response = await ApiService.axiosApi(`/projectsettings/getallproject`, {
          method: 'GET'
        })
        if (response.success) {
         
          setProjectData(response.data.data[0].projectName)
        } else {
          console.log(response.message || response.status || "unable to get projects")
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    fetchProjects();
  }, [])

  if (loading) {
    return <LoadingComponent/>

  }

  return (
    <Container fluid className="p-0">
      <Row className="m-0" >
       
          <div className="login-card login-dark " >

            <div  >
              <div>
                <div className='text-lg-center' >
                  <h4 className="heading" style={{ fontSize: '35px', fontWeight: '600', fontFamily: 'Ysabeau, sans-serif', lineHeight: '42px' }}>{projectData}</h4>
                </div>
                <Link className="logo m-0" to={routes.Login}>
                  <Image className="img-fluid for-light" src={dynamicImage(`logo/logo1.png`)} alt="loginPage" style={{ margin: "10px" }} />
                  <Image className="img-fluid for-light" src={dynamicImage(`logo/logo4.png`)} alt="loginPage" style={{ margin: "10px" }} />
                  <Image className="img-fluid for-light" src={dynamicImage(`logo/logo3.png`)} alt="loginPage" style={{ margin: "10px" }} />
                  <Image className="img-fluid for-light" src={dynamicImage(`logo/logo7.png`)} alt="loginPage" style={{ margin: "10px" }} />
                </Link>
              </div>
              <div className="d-flex align-items-center m-0">
                <div className="login-main" style={{ borderRadius: "0" }}>
                  <SignInForm />
                </div>
                <Image className="img-fluid for-light" src={dynamicImage(`logo/login-bg-new.jpg`)} alt="loginPage" style={{ opacity: 0.7 }} />
              </div>
              <h5 style={{ marginLeft: '600px', color: "#9f9f9f" }}>Powered by TechBrain Info Solution</h5>
            </div>
          </div>
        
      </Row>
    </Container>
  );
};

export default Auth;
